import { Chakra } from "@airhelp/react-ui-components";
import config from "config/config";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import { useDeviceSize } from "hooks";
import { PostListItemsMobile, PostListItemsDesktop } from "./PostListItems";
import type { RelatedArticlesProps } from "./RelatedArticles.d";

const { Box, Heading } = Chakra;

const RelatedArticles = ({ relatedArticles, fallbackFeaturedImage }: RelatedArticlesProps) => {
  const translations = useTranslations();
  const { isTabletOrDesktop } = useDeviceSize();

  return (
    <Box
      bgColor="greyscale.300"
      bgRepeat="no-repeat"
      bgImage={{
        base: "none",
        lg: `url(${config.staticUrl}/i/homepage/decoration-img-triangles-2.svg)`,
      }}
      bgPosition="-130px 30px"
      pt={{ base: 14, lg: 24 }}
    >
      <Box width="100%" maxWidth="1202px" px={4} mx="auto">
        <Heading variant="h2" as="h2" mb={10}>
          {translations("related_articles")}
        </Heading>

        {isTabletOrDesktop ? (
          <PostListItemsDesktop relatedArticles={relatedArticles} fallbackFeaturedImage={fallbackFeaturedImage} />
        ) : (
          <PostListItemsMobile
            relatedArticles={relatedArticles}
            fallbackFeaturedImage={fallbackFeaturedImage}
            width={72}
            mb={12}
            mr={6}
            _last={{ mr: 0 }}
          />
        )}
      </Box>
    </Box>
  );
};

export default RelatedArticles;
